import React from 'react'
import selectn from 'selectn'
import { Video } from '../../common'
import { getPlayerRoles, getBatsmanComm } from '../../../lib/utils/common'
import classnames from 'classnames'

var Entities = require('html-entities').XmlEntities

const entities = new Entities()

/**
 * Print a inline list of players
 * @return {React.Element} list of players
 */
const MultiplePlayers = ({
  players = [],
  remainingBatsmen = ''
}) => {
  return (
      <div className="flex-row">
        <div className="wrap dnb">
          <div className="cell">
            <span className="text-bold">{remainingBatsmen}: </span>
            {
              players.map((p = {}, i) => <a key={i} href={p.href}><span dangerouslySetInnerHTML={getPlayerRoles(p.name, p.roles, i==players.length-1 ?  '' : ', ') }></span></a>)
            }
          </div>
        </div>
      </div>
  )
}


/**
 * get fall of wicket markup.
 * Function is required since text appears in text nodes and not inside any
 * wrapper nodes.
 *
 * @param  {Array}  fows strings of wickets fallen
 * @return {Object}      html markup object
 */
function getFowMarkup( fows = [] ) {
  let fowMarkup = ''
  if (fows.length > 0) {
    fowMarkup = `<span class="text-bold">Fall of wickets: </span>${fows.join(', ')}`
  }
  return { __html : fowMarkup }
}

/**
 * Get markup of the commentary for each out batsman.
 * @param  {Object}  batsman
 * Format is {over number } {out commentary} {fall of wicket i.e. runs/wicket}
 * @return {Object} markup html
 */
function getCommentaryMarkup( batsman = {}) {
  let overs = selectn('runningOver.overs', batsman) || ''
  let runs = selectn('runningScore.runs', batsman)
  let wickets = selectn('runningScore.wickets', batsman) || ''
  let commentary = []
  if(overs != '') {
    commentary.push( `<span class="text-bold"> ${overs} </span>`)
  }

  if(typeof batsman.commentary != 'undefined' && batsman.commentary != '') {
    commentary.push(batsman.commentary)
  }

  // Store run and wickets
  let runsWickets = []
  // Push runs and wickets if available
  if (typeof runs !== 'undefined') {
    runsWickets.push(runs)
  }
  if (wickets !== '') {
    runsWickets.push(wickets)
  }

  // Append to comms only if runs/wickets are available
  if(runsWickets.length !== 0) {
    commentary.push( `<span class="text-bold"> ${runsWickets.join('/')} </span>`)
  }
  return { __html : entities.decode(commentary.join(' ')) }
}

const Batting = ({
  batsmen = [],
  didNotBat = [],
  absent = [],
  total = '',
  extras = '',
  remainingBatsmen = '',
  id,
  isWebView = false,
  keys = {},
  fows = []
}) => {
  return (
    <div className="scorecard-section batsmen">
      {
        batsmen.map((batsman = { stats: [] }, i) => {
          const stats = batsman ? batsman.stats : []
          return (
            batsman && 
            (
            <div key={i} className="flex-row">
              {
                i === 0 &&
                <div className="wrap header">
                  <div className="cell batsmen">BATSMEN</div>
                  <div className="cell commentary"></div>
                  {
                    stats && stats.map((s = {}, j) =>( 
                      keys[s.name] == true ?(
                      <div key={j} className="cell runs">{s && s.text}</div>)
                      : null ))
                  }
                  <div className="cell highlight"></div>
                </div>
              }
              <div className="wrap batsmen">
                <div className="cell batsmen">
                  <a name={batsman.trackingName} href={batsman.href} dangerouslySetInnerHTML={getPlayerRoles(batsman.name, batsman.roles)}></a>
                </div>

                <div className="cell commentary" dangerouslySetInnerHTML={getBatsmanComm(batsman, i, id)}></div>

                {
                  stats && stats.map((s = {}, j) => (
                    keys[s.name] == true ? (
                      <div key={j} className="cell runs">{s && s.value}</div>)
                      : null ))
                }
                <div className="cell highlight active">
                  {
                    batsman.hasVideoId &&
                    <a key={batsman.videoId} data-linktype="lecvideo" className={classnames('highlight icon-font-after icon-play-solid-after gamepackage_bloom module_bloom_behavior', { 'app_partial' : isWebView } )} data-behavior="module_bloom" data-id={batsman.videoId}>
                      <Video {...batsman.video} showCaption={true} className=""/>
                    </a> || null
                  }
                </div>
              </div>
              {
              batsman.commentary &&
              <div id={'commentary-00' + (i+1) + '-' + id} className="commentary-content collapse">
                  <div className="content" dangerouslySetInnerHTML={ getCommentaryMarkup(batsman) } />
              </div> || null
              }
            </div>
            )
          )
        })
      }

      {
        absent.map((absentHurt = {} , i) => {
          return (
            absentHurt && (
                <div key={i} className="flex-row">
                  <div className="wrap batsmen">
                    <div className="cell batsmen">
                      <a name={absentHurt.trackingName} href={absentHurt.href} dangerouslySetInnerHTML={getPlayerRoles(absentHurt.name, absentHurt.roles)}></a>
                    </div>
                    <div className="cell commentary" dangerouslySetInnerHTML={getBatsmanComm(absentHurt, i, id)}></div>
                    <div className="cell runs" style={{ clear:'both', width:'26%',textAlign:'left' }}> - </div>
                  </div>
                </div>
              )
            )
        })
      }
      {
        extras && 
      <div className="flex-row">
        <div className="wrap extras">
          <div className="cell">Extras</div>
          <div className="cell">{extras}</div>
        </div>
      </div>
      }
      {
        total && 
      <div className="flex-row">
        <div className="wrap total">
          <div className="cell">TOTAL</div>
          <div className="cell">{total}</div>
        </div>
      </div>
      }
      {
        didNotBat && didNotBat.length &&
        <MultiplePlayers players={didNotBat} remainingBatsmen={remainingBatsmen}/> || null
      }

      { 
        fows && fows.length > 0 &&
        <div className="flex-row">
          <div className="wrap dnb">
            <div className="cell" dangerouslySetInnerHTML={getFowMarkup(fows)}></div>
          </div>
        </div> || null
      }

    </div>
  )
}

const Bowling = ({
  bowlers = [],
  isWebView,
  keys = {}
}) => {

  const firstBowler = bowlers[0] || {}
  const stats = firstBowler.stats || []
  const playIconClass = classnames('highlight icon-font-after icon-play-solid-after gamepackage_bloom module_bloom_behavior', { 'app_partial' : isWebView } )

  if(bowlers && (bowlers.length === 0)) {
    return <span />
  }
  return (
    <div className="scorecard-section bowling">
      <table cellSpacing="0" cellPadding="0" data-fix-cols="0" data-behavior="responsive_table">
        <thead>
          <tr>
            <th>Bowling</th>
            <th className="highlight mobile"></th>
            {
              stats.map((s = {}, j) => {
                return  ( s && s.value != '' && keys[s.name] &&
                  ( <th key={j} className="cell runs">{s.text}</th> ))})
            }
            <th className="highlight"></th>
          </tr>
        </thead>
        <tbody>
          {
            bowlers.map((bowler = {} , i) => {
              return (
                bowler && 
                (
                <tr key={i}>
                  <td><a name={bowler.trackingName} href={bowler.href}>{`${bowler.name}`}</a></td>
                  <td className="highlight mobile active">
                    {
                      bowler.hasVideoId &&
                      <a data-linktype="lecvideo" className={playIconClass}  data-behavior="module_bloom" data-id={bowler.videoId}>
                        <Video {...bowler.video} showCaption={true} className=""/>
                      </a> || null
                    }
                  </td>
                  {
                    (bowler && bowler.stats || []).map((s = {}, j) => {
                      return s && s.value != '' && keys[s.name] && (  <td key={j}>{s.value}</td>  )
                    })
                  }
                  <td className="highlight active">
                    {
                      bowler.hasVideoId &&
                      <a data-linktype="lecvideo" className={playIconClass} data-behavior="module_bloom" data-id={bowler.videoId}>
                        <Video {...bowler.video} showCaption={true} className=""/>
                      </a> || null
                    }
                  </td>
                </tr>
                )
              )
            })
          }

       </tbody>
      </table>
    </div>
  )
}

const Team = ({
  details = {}
}) => {
  return (
    <div className="scorecard-section board">
      <table cellSpacing="0" cellPadding="0">
        <thead>
        <tr>
          <th colSpan="2">{details.name} Team</th>
        </tr>
        </thead>
        <tbody>

        {
          details.players.map((player = {}, i) => {
            return (
                <tr key={i}>
                  <td><a href={player.href} dangerouslySetInnerHTML={getPlayerRoles(player.name, player.roles)}></a></td>
                  <td>{player.athleteRole || player.role}</td>
                </tr>
            )
          })
        }

        </tbody>
      </table>
    </div>
  )
}

export const Inning = ({
  title = 'Innings',
  batsmen = [],
  bowlers = [],
  didNotBat = [],
  absent = [],
  total = '',
  extras = '',
  remainingBatsmen = '',
  fows = [],
  id,
  otherTeamDetails = {},
  isWebView = false,
  batsmenKeys = {},
  bowlerKeys = {},
  headerInfo = '',
  isSmallDevice,
  isCurrent = false,
  gameState = ''
}) => {
  const inningsTitle = (isSmallDevice === false) ? `${title} ${headerInfo}` : `${title}`
  const openClose = gameState === 'live' ? isCurrent : true
  const ariaExpanded = openClose ? true : false
  return (
    <article className="sub-module scorecard">
      <ul className="css-accordion">
        <li className="accordion-item">
          <div className="accordion-header">
            <a role="button" data-toggle="collapse" href={'#gp-inning-0' + id} aria-expanded={ariaExpanded} aria-controls={'gp-inning-0' + id} className={openClose ? '' : 'collapsed'}>
              <h2>{inningsTitle}</h2>
            </a>
          </div>
          <div id={'gp-inning-0' + id} className={classnames('accordion-content collapse', { 'in' : openClose })} aria-expanded={ariaExpanded}>
            <Batting id={id} batsmen={batsmen} didNotBat={didNotBat} absent={absent} total={total} extras={extras} remainingBatsmen={remainingBatsmen} fows={fows} isWebView={isWebView}keys = {batsmenKeys} />
            <Bowling id={id} bowlers={bowlers} isWebView={isWebView} keys={bowlerKeys} />
            {
              otherTeamDetails && otherTeamDetails.players.length && <Team details={otherTeamDetails}/> || null
            }
          </div>
        </li>
      </ul>
    </article>
  )
}


export const Innings = ({
  innings = {},
  otherTeamDetails = {},
  isWebView = false,
  isSmallDevice,
  showSquads = false,
  rosters = {},
  gameState = ''
}) => {
  return (
    <div>
      {
        Object.keys(innings).map((inning, i) => {
          return <Inning key={i} id={i} {...innings[inning]} otherTeamDetails={otherTeamDetails} isWebView={isWebView} isSmallDevice={isSmallDevice} gameState={gameState} />
        })
      }
      { showSquads &&
        [ rosters.home, rosters.away ].map((team, i) => {
          return (
            <article key={i} className="sub-module scorecard">
              { team && team.players.length && <Team details={team}/> || '' }
            </article>
          )
        })
      }
    </div>
  )
}

export default Innings



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/Innings.jsx
 **/